import { Stats, StatsDto, StatsProps } from "@domain";
import { UniqueEntityId } from "@kernel/ddd";
import { SyncInteractor } from "@kernel/frontend-react-app";

export interface GetStatsLiveInteractorProps {
  dto: StatsDto | null;
}

export class GetStatsLiveInteractor extends SyncInteractor<
  GetStatsLiveInteractorProps,
  Stats | null
> {
  public execute({ dto }: GetStatsLiveInteractorProps): Stats | null {
    if (dto === null) {
      return null;
    }
    return this.buildStats(dto);
  }

  private buildStats(dto: StatsDto): Stats {
    const props: StatsProps = {
      roomName: dto.roomName,
      timestamp: dto.timestamp,
      report: dto.report
    };
    return Stats.create(props, new UniqueEntityId(dto.id));
  }

  public static create(): GetStatsLiveInteractor {
    return new GetStatsLiveInteractor();
  }
}
